import { render } from "./NotificationsProvider.vue?vue&type=template&id=ea0e9500&scoped=true&ts=true"
import script from "./NotificationsProvider.vue?vue&type=script&lang=ts"
export * from "./NotificationsProvider.vue?vue&type=script&lang=ts"

import "./NotificationsProvider.vue?vue&type=style&index=0&id=ea0e9500&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea0e9500"]])

export default __exports__